var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn" }, [
    !_vm.organization.id
      ? _c("div", [
          _c("p", [
            _vm._v(
              "Organization not found, or you do not have access to this organization in the given Org/Group context."
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.organization.id
      ? _c(
          "div",
          [
            _c(
              "b-form",
              { on: { submit: _vm.addOrUpdateOrganizationRecord } },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "mb-4", attrs: { md: "9", sm: "12" } },
                      [
                        _vm._.get(this.organization, "id", false)
                          ? _c("h4", { staticClass: "card-title mb-0" }, [
                              _vm._v(_vm._s(this.organization.title))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !this.organization.id
                          ? _c("h4", { staticClass: "card-title mb-0" }, [
                              _vm._v("Update Organization")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(
                            "Added " + _vm._s(_vm.getOrganizationAddedDate())
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("OrganizationForm", {
                          attrs: { organization: _vm.organization }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-alert",
                          {
                            attrs: {
                              fade: "",
                              show: _vm.UpdateOrganizationFailure,
                              variant: "danger"
                            }
                          },
                          [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.UpdateOrganizationFailure)
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { attrs: { "align-h": "end" } },
                          [
                            _c(
                              "b-col",
                              { staticClass: "p-3", attrs: { cols: "auto" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "secondary",
                                      href:
                                        "/admin/organizations/" +
                                        _vm.organization.id
                                    }
                                  },
                                  [_vm._v("Cancel")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: _vm.addOrUpdateOrganizationRecord
                                    }
                                  },
                                  [_vm._v("Submit")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "h2",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.UpdateOrganizationPending,
                    expression: "UpdateOrganizationPending"
                  }
                ],
                staticClass: "u-padding-bottom-20"
              },
              [_vm._v("Updating, please wait ...")]
            ),
            _vm._v(" "),
            _c("pulse-loader", {
              attrs: {
                loading: _vm.UpdateOrganizationPending,
                color: "#0F347B",
                size: "50px"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31003345", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31003345","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/EditOrganization.vue
// module id = 1899
// module chunks = 0